import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Warner_Title } from '../../../../../utils/ES/Modals/PostModals';

const ModalPostWarner = () => {
  return (
    <>
      <ModalVideo
        id="warner-post"
        dataText={Warner_Title}
        videoSrc="https://player.vimeo.com/video/98821756?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_WARNER"
      />
    </>
  );
};

export default ModalPostWarner;
